import { render, staticRenderFns } from "./jsycDetail.vue?vue&type=template&id=357d4793&"
import script from "./jsycDetail.vue?vue&type=script&lang=js&"
export * from "./jsycDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports